var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 3.75C10.2052 3.75 8.75004 5.20507 8.75004 7C8.75004 7.41421 8.41426 7.75 8.00004 7.75C7.58583 7.75 7.25004 7.41421 7.25004 7C7.25004 4.37665 9.37669 2.25 12.0001 2.25C14.6234 2.25 16.7501 4.37665 16.7501 7C16.7501 9.21866 15.2297 11.0803 13.175 11.6034C13.0376 11.6384 12.92 11.7105 12.8443 11.7921C12.7725 11.8697 12.7501 11.9403 12.7501 12V12.6395L22.4686 20.4143C22.7173 20.6133 22.8132 20.9477 22.7078 21.2483C22.6024 21.5488 22.3186 21.75 22.0001 21.75H2.00004C1.68152 21.75 1.39775 21.5488 1.29232 21.2483C1.18689 20.9477 1.2828 20.6133 1.53152 20.4143L11.2501 12.6395V12C11.2501 11.0011 12.0497 10.342 12.8049 10.1498C14.211 9.7918 15.2501 8.51631 15.2501 7C15.2501 5.20507 13.795 3.75 12.0001 3.75ZM12.0001 13.9605L4.13813 20.25H19.862L12.0001 13.9605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger);
export default __webpack_public_path__ + "static/media/hanger.70b53870d3237b9c4bc6e88fb1f05e96.svg";
export { ForwardRef as ReactComponent };